<ion-content color="lightmimbo">
  <ion-grid>
    <ion-row>
      <ion-col sizeXl=" 10" offsetXl="1">
        <ion-segment value="dogs" [(ngModel)]="filter" (ionChange)="filterBehaviors()">
          <ion-segment-button value="dogs">
            <ion-label>
              Dogs
            </ion-label>
          </ion-segment-button>
          <ion-segment-button value="cats">
            <ion-label>
              Cats
            </ion-label>
          </ion-segment-button>
        </ion-segment>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeXl="10" offsetXl="1">
        <ion-accordion-group>
          <ion-accordion *ngFor="let action of actionList">
            <ion-item slot="header" color="lightmimbo">
              <ion-label color="darkmimbo">{{action.action}}</ion-label>
            </ion-item>
            <ion-item slot="content" class="ion-padding background-lightmimbo" lines="none" color="lightmimbo">
              <ion-text>{{action.meaning}}</ion-text>
            </ion-item>
          </ion-accordion>
        </ion-accordion-group>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>